<div class="modal-body">
    <p class="text-center">
        For security purposes your session has expired, and you have been logged out of your account.
    </p>
</div>

<div class="modal-footer flex-row align-items-center justify-center">
    <button class="btn primary-button" (click)="activeModal.dismiss('clicked close')">Close</button>
</div>
